import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
import useFormControl from './useFormControl';
import Text from '../Text';
const Root = styled(Text).withConfig({
  displayName: "FormFeedback__Root",
  componentId: "sc-13iubq-0"
})(["", " display:block;color:var(--color-gray-80);margin-top:var(--size-spacing-02);", " ", ""], ScopedCssBaseline, ({
  success
}) => success && css(["color:var(--color-green-70);"]), ({
  error
}) => error && css(["color:var(--color-red-60);"]));
const FormFeedback = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    as,
    children,
    error: errorProp,
    success: successProp
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["as", "children", "error", "success"]);

  const {
    error: errorContext,
    success: successContext
  } = useFormControl();
  const error = errorContext || errorProp;
  const success = successContext || successProp;
  return /*#__PURE__*/React.createElement(Root, _extends({
    ref: ref,
    forwardedAs: as,
    token: Text.tokens.TEXT_SM_REGULAR,
    error: error,
    success: success
  }, rest), children);
});
FormFeedback.displayName = 'FormFeedback';
FormFeedback.defaultProps = {
  children: null,
  as: 'span'
};
process.env.NODE_ENV !== "production" ? FormFeedback.propTypes = {
  /**
   * Sets the children
   */
  children: PropTypes.node.isRequired,

  /**
   * Sets the error state for feedback message
   */
  error: PropTypes.bool,

  /**
   * Sets the success state for feedback message
   */
  success: PropTypes.bool
} : void 0;
export default FormFeedback;